import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

// users
import user1 from "../../../assets/images/users/user_logo.jpeg";
import { useSelector } from "react-redux";
const ProfileMenu = (props) => {
	// Declare a new state variable, which we'll call "menu"
	const [menu, setMenu] = useState(false);
	const user = useSelector((state) => state?.Auth);
	const [username, setusername] = useState("Admin");
	const type = useSelector((state) => state.Auth.userType);

	useEffect(() => {
		if (localStorage.getItem("authUser")) {
			if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
				const obj = JSON.parse(localStorage.getItem("authUser"));
				setusername(obj.displayName);
			} else if (
				process.env.REACT_APP_DEFAULTAUTH === "fake" ||
				process.env.REACT_APP_DEFAULTAUTH === "jwt"
			) {
				const obj = JSON.parse(localStorage.getItem("authUser"));
				setusername(obj.username);
			}
		}
	}, [props.success]);

	return (
		<React.Fragment>
			<Dropdown
				isOpen={menu}
				toggle={() => setMenu(!menu)}
				className="d-inline-block">
				<DropdownToggle
					className="btn header-item waves-effect"
					id="page-header-user-dropdown"
					tag="button">
					<img
						className="rounded-circle header-profile-user"
						src={user1}
						alt="Header Avatar"
					/>
					<span className="d-none d-xl-inline-block ms-2 me-1">
						{type === "provider"
							? "Sales Rep"
							: type === "admin"
							? user?.user_name
							: "Sales Developer"}
					</span>
					<i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
				</DropdownToggle>
				<DropdownMenu className="dropdown-menu-end">
					{/* <Link to={props.routePrefix + '/profile'} className="dropdown-item">
                        <i className="bx bx-user font-size-16 align-middle me-1"/>
                        {props.t("Profile")}{" "}
                    </Link> */}
					{/* <div className="dropdown-divider"/> */}
					<Link to={props.routePrefix + "/logout"} className="dropdown-item">
						<i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
						<span>{props.t("Logout")}</span>
					</Link>
				</DropdownMenu>
			</Dropdown>
		</React.Fragment>
	);
};

ProfileMenu.propTypes = {
	success: PropTypes.any,
	routePrefix: PropTypes.string,
	t: PropTypes.any,
};

const mapStatetoProps = (state) => {
	const { error, success } = state;
	return { error, success };
};

export default withRouter(
	connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
